import { render, staticRenderFns } from "./SorteoEstadisticaGlobales.vue?vue&type=template&id=6351479d&"
import script from "./SorteoEstadisticaGlobales.vue?vue&type=script&lang=ts&"
export * from "./SorteoEstadisticaGlobales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports